import { getGoliathImages } from "../goliath-media.js";
import { getPrice } from "../price-utils/index.js";
const getProductAvailability = (amount) => {
    if (amount >= 1)
        return "https://schema.org/InStock";
    return "https://schema.org/OutOfStock";
};
/**
 * Returns a product in Schema.org JSON LD format based on a Goliath Offer.
 */
const generateJsonLdData = (offer, baseUrl) => {
    const product = offer?.product;
    if (!product?.name || !product.articleNumber)
        return undefined;
    const schema = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: product.name,
        image: getGoliathImages(offer).map((image) => `${baseUrl}${image.large}`),
        description: offer.usps?.join(", "),
        sku: product.articleNumber,
        offers: {
            "@type": "Offer",
            url: `${baseUrl}/geraete/${product.slug}`,
            priceCurrency: "EUR",
            price: getPrice(offer.prices || [], "DEFAULT", "ONETIME")?.value,
            itemCondition: "https://schema.org/NewCondition",
            availability: getProductAvailability(product.stock?.amount || product.availability?.stock || 0),
        },
    };
    if ("brand" in product && product?.brand?.name) {
        schema.brand = {
            "@type": "Brand",
            name: product.brand.name || undefined,
        };
    }
    return schema;
};
export default generateJsonLdData;
